import React from 'react'
import _Input from './Input/Input'
import { format } from 'd3-format'

export const Input = props => (
  <_Input
    {...props}
    onValueChange={text => props.onValueChange && props.onValueChange(text.length ? parseInt(text, 10) : '')}
    type='number'
    step={props.stepSize}
    min={props.minNum}
    max={props.maxNum}
  />
)

export const Output = props => {
  let data = props.data != null ? props.data : props.value
  return <span>{format(props.numberFormat || ',.2r')(parseInt(data) ? data : 0)}</span>
}
